import { render, staticRenderFns } from "./forums-lists.vue?vue&type=template&id=435c21d9&scoped=true"
import script from "./forums-lists.vue?vue&type=script&lang=js"
export * from "./forums-lists.vue?vue&type=script&lang=js"
import style0 from "./forums-lists.vue?vue&type=style&index=0&id=435c21d9&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "435c21d9",
  null
  
)

export default component.exports